export const FILED_NAMES = {
  currentExchangeRate: 'cost.currentExchangeRate',
  useSetExchangeRate: 'cost.useSetExchangeRate',
};
